/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './disqus.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../../app/shared/comments/disqus.component';
import * as import3 from '@angular/platform-browser';
const styles_DisqusComponent:any[] = [import0.styles];
export const RenderType_DisqusComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_DisqusComponent,
  data: {}
}
);
export function View_DisqusComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'comments-background'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.DisqusComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.hideComments()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),16,'div',[[
        'class',
        'comments-wrap'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),13,'div',[[
        'class',
        'comments'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'close-comments-button'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import2.DisqusComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.hideComments()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵeld(0,(null as any),(null as any),0,'i',[
      [
        'aria-hidden',
        'true'
      ]
      ,
      [
        'class',
        'fa fa-chevron-left'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),[' Back to the article'])),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),6,'nav',[[
        'id',
        'ml-comment'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'comments__wrap'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'id',
        'disqus_thread'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n']))
  ]
  ,(null as any),(null as any));
}
function View_DisqusComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'disqus',([] as any[]),(null as any),(null as any),(null as any),View_DisqusComponent_0,RenderType_DisqusComponent)),
    import1.ɵdid(180224,(null as any),0,import2.DisqusComponent,[
      'isBrowser',
      import3.DOCUMENT,
      import1.Renderer2,
      import1.ElementRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const DisqusComponentNgFactory:import1.ComponentFactory<import2.DisqusComponent> = import1.ɵccf('disqus',import2.DisqusComponent,View_DisqusComponent_Host_0,{
  pageIdentifier: 'page-identifier',
  pageUrl: 'page-url',
  pageLanguage: 'page-language',
  shortname: 'shortname'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvc2hhcmVkL2NvbW1lbnRzL2Rpc3F1cy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2J1aWxkL2hvd211Y2gvc3JjL2FwcC9zaGFyZWQvY29tbWVudHMvZGlzcXVzLmNvbXBvbmVudC50cyIsIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvc2hhcmVkL2NvbW1lbnRzL2Rpc3F1cy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9idWlsZC9ob3dtdWNoL3NyYy9hcHAvc2hhcmVkL2NvbW1lbnRzL2Rpc3F1cy5jb21wb25lbnQudHMuRGlzcXVzQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNvbW1lbnRzLWJhY2tncm91bmRcIiAoY2xpY2spPVwiaGlkZUNvbW1lbnRzKClcIj48L2Rpdj5cbjxkaXYgY2xhc3M9XCJjb21tZW50cy13cmFwXCI+XG4gIDxkaXYgY2xhc3M9XCJjb21tZW50c1wiPlxuICAgIDxkaXYgY2xhc3M9XCJjbG9zZS1jb21tZW50cy1idXR0b25cIiAoY2xpY2spPVwiaGlkZUNvbW1lbnRzKClcIj48aSBjbGFzcz1cImZhIGZhLWNoZXZyb24tbGVmdFwiIGFyaWEtaGlkZGVuPVwidHJ1ZVwiPjwvaT4mbmJzcDtCYWNrIHRvIHRoZSBhcnRpY2xlPC9kaXY+XG4gICAgPG5hdiBpZD1cIm1sLWNvbW1lbnRcIj5cbiAgICAgIDxkaXYgY2xhc3M9XCJjb21tZW50c19fd3JhcFwiPlxuICAgICAgICA8ZGl2IGlkPVwiZGlzcXVzX3RocmVhZFwiPjwvZGl2PlxuICAgICAgPC9kaXY+XG4gICAgPC9uYXY+XG4gIDwvZGl2PlxuPC9kaXY+XG5cbiIsIjxkaXNxdXM+PC9kaXNxdXM+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUFpQztRQUFBO1FBQUE7TUFBQTtNQUFqQztJQUFBO0lBQWdFO01BQ2hFO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBMkI7TUFDekI7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFzQjtNQUNwQjtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO01BQW1DO1FBQUE7UUFBQTtNQUFBO01BQW5DO0lBQUE7SUFBNEQ7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBQXFEO0lBQStCO01BQ2hKO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBcUI7TUFDbkI7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUE0QjtNQUMxQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQThCO0lBQzFCO0lBQ0Y7SUFDRjtJQUNGOzs7Ozs7SUNWTjtnQkFBQTtNQUFBOzs7O0lBQUE7S0FBQTs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/ngfactory/app/shared/comments/disqus.component.ngfactory.ts